import React from 'react'

function SigupForm() {
  return (
    <div>SigupForm</div>
  )
}

export default SigupForm